
function bindGrantNames($scope, ModelService) {
    ModelService.index('grant_name', {enabled:true}).then(function(names) {
        $scope.grantNames = names;
    });
}


module.directive('grantForm', function(ModelService) {
    var fields = ['grant_name_id', 'grant_start_date', 'grant_end_date',
                  'grant_status', 'grant_amount']
    return {
        restrict: 'E',
        templateUrl: 'programs/grants/grantForm',
        scope: {grant: '=', canDelete: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.grant, fields);
            basicForm.data = scope.data;
            scope.form = basicForm.getForm()

            bindGrantNames(scope, ModelService);

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.grant, data);
            };

            basicForm.setDeleteFunctions(function() {
                return ModelService.deleteModel(scope.grant);
            }, function() {
                return scope.canDelete;
            });
        },
    };
});

module.directive('newGrantForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'programs/grants/grantForm',
        scope: {program: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            basicForm.data = scope.data = {};
            scope.form = basicForm.getForm();
            bindGrantNames(scope, ModelService);

            basicForm.save = function(data) {
                return ModelService.postModelRelation(
                    scope.program, 'grants', data);
            };
        },
    };
});
